"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function ToReactEventHandler(onChange) {
    if (!onChange)
        return undefined;
    return function (e) { return onChange(e.currentTarget.value); };
}
exports.ToReactEventHandler = ToReactEventHandler;
